import { render, staticRenderFns } from "./CreateNewClassroomPage.vue?vue&type=template&id=08971572&scoped=true"
import script from "./CreateNewClassroomPage.vue?vue&type=script&lang=js"
export * from "./CreateNewClassroomPage.vue?vue&type=script&lang=js"
import style0 from "./CreateNewClassroomPage.vue?vue&type=style&index=0&id=08971572&prod&lang=stylus&scoped=true"
import style1 from "./CreateNewClassroomPage.vue?vue&type=style&index=1&id=08971572&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08971572",
  null
  
)

export default component.exports